/* tslint:disable */
/* eslint-disable */
/**
 * Unified API STS Service Public
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface Token {
    /**
     * The short term access token
     */
    'access_token': string;
    /**
     * amount of seconds after which token expires
     */
    'expires_in': number;
    'token_type': TokenTokenTypeEnum;
    'scope'?: string;
}

export enum TokenTokenTypeEnum {
    Bearer = 'Bearer'
}


